import e, { StrictMode as t, Suspense as n, useCallback as r } from "react";
import { QueryClient as i, QueryClientProvider as a } from "@tanstack/react-query";
import { ErrorBoundary as o } from "@reapitform/utils";
import { Toaster as s, toast as c } from "@reapit/elements/core/toaster";
import { jsx as l } from "react/jsx-runtime";
import { useReapitConnect as u } from "@reapit/connect-session";
import { reapitConnectBrowserSession as d, useLoadScript as f } from "@reapitform/hooks";
import { Outlet as p, redirect as m, useLocation as h } from "react-router";
import { MainContainer as g } from "@reapit/elements/core/main-container";
import { Loader as _ } from "@reapit/elements/deprecated/loader";
//#region src/main-app-render.tsx
var v = new i(), y = (e) => /* @__PURE__ */ l(t, { children: /* @__PURE__ */ l(a, {
	client: e.queryClient || v,
	children: /* @__PURE__ */ l(o, { children: /* @__PURE__ */ l(s, {
		position: "top-right",
		children: e.children
	}) })
}) }), b = () => {
	let { connectSession: e, connectInternalRedirect: t } = u(d), r = h();
	return e ? (t && r?.pathname !== t && m(t), /* @__PURE__ */ l(g, {
		size: "wide",
		backgroundColour: "--colour-fill-neutral-lightest",
		hasNoTopPadding: !0,
		hasNoBottomPadding: !0,
		children: /* @__PURE__ */ l(n, {
			fallback: /* @__PURE__ */ l(_, { fullPage: !0 }),
			children: /* @__PURE__ */ l(p, {})
		})
	})) : /* @__PURE__ */ l(g, {
		size: "wide",
		backgroundColour: "--colour-fill-neutral-lightest",
		hasNoTopPadding: !0,
		hasNoBottomPadding: !0,
		children: /* @__PURE__ */ l(_, { fullPage: !0 })
	});
}, x = "https://consolegroup.my.site.com/ESWMessagingIRE1723083955131", S = "https://consolegroup.my.salesforce-scrt.com", C = "00Dj0000001p7lS", w = "Messaging_IRE", T = !1, E = ({ firstName: t, email: n, lastName: i, officeId: a, officeName: o, userRole: s }) => {
	let c = r(() => {
		if (!a || !o || !s) return;
		let e = () => {
			window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
				_firstName: {
					value: t,
					isEditableByEndUser: !0
				},
				_lastName: {
					value: i,
					isEditableByEndUser: !0
				},
				_email: {
					value: n,
					isEditableByEndUser: !0
				}
			}), window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
				Office_Login: a,
				Product: "Reapit Forms",
				User_Role: s,
				Main_Office: o
			});
		};
		try {
			e();
		} catch {}
		return window.addEventListener("onEmbeddedMessagingReady", e), () => window.removeEventListener("onEmbeddedMessagingReady", e);
	}, [
		t,
		i,
		n,
		a,
		o,
		s
	]);
	e.useEffect(() => {
		let e = c();
		return () => {
			e?.();
		};
	}, [c]);
	let { error: l, isLoading: u, loadScript: d } = f({
		onLoad: r(() => {
			window.embeddedservice_bootstrap.settings.language = "en", window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = !0, window.embeddedservice_bootstrap.init(C, w, x, { scrt2URL: S });
		}, []),
		src: !1
	});
	return e.useEffect(() => {
		if (!l || u) return;
		let e = setTimeout(() => d(), 5e3);
		return () => clearTimeout(e);
	}, [
		l,
		u,
		d
	]), null;
}, D = ({ window: t = window }) => {
	let [n, i] = e.useState(!1), [a, o] = e.useState(!1), [s, l] = e.useState(!1);
	return {
		startChat: r(function(e = "") {
			if (!n && (i(!0), o(!1), l(!1), t.embeddedservice_bootstrap)) try {
				t.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
					Cloud_URL: t.location.href,
					Chat_Intent: e
				}), window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({ _subject: {
					value: "Reapit Forms Support",
					isEditableByEndUser: !0
				} }), t.embeddedservice_bootstrap.utilAPI.launchChat().then(() => {
					l(!0);
				}).catch(() => {
					o(!0);
				}).finally(() => {
					i(!1);
				});
			} catch {
				c.error("Unable to start live chat"), i(!1), o(!0);
			}
		}, [t]),
		isError: a,
		isSuccess: s,
		isLoading: n
	};
};
//#endregion
export { E as LoadSalesforceLiveChat, y as MainAppRender, b as PrivateRouteWrapper, T as SALESFORCE_SERVICE_ENABLE, v as queryClient, D as useStartSalesforceLiveChat };
